const default_color_scheme = {
    log: { category_name: 'white', background: 'grey' },
    info: { category_name: 'white', background: 'blue' },
    debug: { category_name: 'white', background: 'violet' },
    warn: { category_name: 'white', background: 'orange' },
    error: { category_name: 'white', background: 'red' },
    default: { category_name: 'white', background: 'grey' }
};
/**
 * Console Decorator
 * @static
 *
 * Utility class to add some style to console logs.
 */
export class ConsoleDecorator {
    constructor() { }
    static get_style(type, color_scheme = default_color_scheme) {
        var _a;
        const color = (_a = color_scheme[type]) !== null && _a !== void 0 ? _a : color_scheme.default;
        return [ConsoleDecorator.create_header_style(color)];
    }
    static create_header_style(pin_color) {
        const { padding, border_radius } = ConsoleDecorator.pin_style;
        const { size, weight } = ConsoleDecorator.pin_font;
        const { category_name, background } = pin_color;
        const style = `padding: ${padding}; border-radius: ${border_radius}; `;
        const font = `font-weight: ${weight}; font-size: ${size}; `;
        const color = `color: ${category_name}; background-color: ${background}; `;
        return style + font + color;
    }
}
ConsoleDecorator.pin_font = {
    size: '0.8rem',
    weight: 'bold'
};
ConsoleDecorator.pin_style = {
    border_radius: '4px',
    padding: '1px 4px'
};
//# sourceMappingURL=ConsoleDecorator.js.map